/**
 * Avalara © 2017
 * file: engines/opus_ui/src/reducers/search.js
 */

import {
  SEARCH_FIELD_UPDATED,
  FETCH_SEARCH_RESULTS_SUCCESS,
  FETCH_SEARCH_RESULTS_REQUEST,
  FETCH_SEARCH_RESULTS_FAILURE,
  FETCH_CARD_RESULTS_SUCCESS,
} from '../actions/search';

import { rankResults } from '../helpers/biztechQueries';

const search = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SEARCH_RESULTS_SUCCESS:
      if (action.data[0]) {
        state.searchResults.push(...action.data);
      }

      state.searchSystemsSuccess.push(action.source);
      state.isFetching =
        state.searchSystems.length >
        state.searchSystemsSuccess.length + state.searchSystemsFailure.length;

      if (!state.isFetching) {
        state.rankedSearchResults = rankResults(
          action.queryString,
          action.caseUrlParam,
          state.searchResults
        );
      }
      return {
        ...state,
        ...{
          queryString: action.queryString,
          requestTotalTime: (
            (Date.now() - state.requestStartTime) /
            1000
          ).toFixed(2),
        },
      };
    case FETCH_SEARCH_RESULTS_FAILURE:
      state.searchSystemsFailure.push(action.source);
      state.isFetching =
        state.searchSystems.lengh >
        state.searchSystemsSuccess.lengh + state.searchSystemsFailure.lengh;
      return {
        ...state,
        ...{
          queryString: action.queryString,
          requestTotalTime: (
            (Date.now() - state.requestStartTime) /
            1000
          ).toFixed(2),
        },
      };
    case FETCH_SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        ...{
          isFetching: true,
          searchSystems: action.searchSystems,
          searchSystemsSuccess: [],
          searchSystemsFailure: [],
          searchResults: [],
          rankedSearchResults: [],
          requestStartTime: Date.now(),
        },
      };
    case FETCH_CARD_RESULTS_SUCCESS: {
      state.rankedSearchResults[0] = action.newCard;
      state.requestTotalTime = (
        (Date.now() - state.requestStartTime) /
        1000
      ).toFixed(2);
      return {
        ...state,
      };
    }

    case SEARCH_FIELD_UPDATED:
      return {
        ...state,
        ...{
          queryString: action.queryString,
        },
      };

    default:
      return state;
  }
};

export default search;
